import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, Store, MapPin, ShoppingBag, User, LogOut, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useCustomer } from "../context/CustomerContext";

const BottomBar = () => {
  const { count, setOpen } = useCart();
  const { user: customer, logout } = useCustomer();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [acct, setAcct] = useState(false);

  const Tab = ({ icon: Icon, label, active, onClick, badge, testid }) => (
    <button
      onClick={onClick}
      data-testid={testid}
      className={`relative flex flex-col items-center justify-center gap-1 flex-1 h-full transition-colors duration-300 ${
        active ? "text-[#f3e5ab]" : "text-zinc-500"
      }`}
    >
      <span className="relative">
        <Icon size={20} strokeWidth={active ? 2 : 1.6} />
        {badge > 0 && (
          <span
            data-testid={`${testid}-badge`}
            className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-[#d4af37] text-[#0a0a0b] text-[9px] font-bold flex items-center justify-center"
          >
            {badge}
          </span>
        )}
      </span>
      <span className="text-[9px] tracking-[0.14em] uppercase">{label}</span>
      {active && <span className="absolute top-0 left-1/2 -translate-x-1/2 w-10 h-[2px] bg-[#d4af37] rounded-full" />}
    </button>
  );

  return (
    <>
      {acct && (
        <div className="fixed inset-0 z-[75] md:hidden" onClick={() => setAcct(false)} data-testid="bottombar-overlay">
          <div className="absolute inset-0 bg-black/60" />
          <div
            className="absolute bottom-[72px] left-3 right-3 glass gold-hairline rounded-2xl p-5"
            onClick={(e) => e.stopPropagation()}
            data-testid="bottombar-account-sheet"
          >
            {customer ? (
              <>
                <p className="text-xs text-zinc-400 mb-4">
                  Signed in as <span className="text-[#f3e5ab]">{customer.email}</span>
                </p>
                <button
                  onClick={() => {
                    logout();
                    setAcct(false);
                  }}
                  className="w-full py-2.5 rounded-lg text-sm text-zinc-200 hover:bg-[#d4af37]/10 flex items-center gap-2 justify-center transition-colors"
                  data-testid="bottombar-logout-button"
                >
                  <LogOut size={15} /> Sign Out
                </button>
              </>
            ) : (
              <>
                <p className="font-serif text-2xl text-zinc-100 text-center">Welcome to Jwellary</p>
                <p className="text-xs text-zinc-500 text-center mt-1 mb-4">Sign in for faster checkout</p>
                <button onClick={() => { setAcct(false); navigate("/login"); }} className="btn-gold w-full !py-2.5" data-testid="bottombar-login-button">
                  Sign In / Create Account
                </button>
              </>
            )}
            <button onClick={() => setAcct(false)} className="absolute top-2 right-2 p-1.5 text-zinc-500 hover:text-zinc-300" data-testid="bottombar-sheet-close" aria-label="Close">
              <X size={15} />
            </button>
          </div>
        </div>
      )}
      <nav
        className="fixed bottom-0 inset-x-0 z-[65] md:hidden glass border-t border-[#d4af37]/25"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
        data-testid="bottom-app-bar"
      >
        <div className="flex h-[62px]">
          <Tab icon={Home} label="Home" active={pathname === "/"} onClick={() => navigate("/")} testid="bottombar-home" />
          <Tab icon={Store} label="Shop" active={pathname.startsWith("/shop")} onClick={() => navigate("/shop")} testid="bottombar-shop" />
          <Tab icon={MapPin} label="Track" active={pathname.startsWith("/track")} onClick={() => navigate("/track")} testid="bottombar-track" />
          <Tab icon={User} label="Account" active={false} onClick={() => setAcct(true)} testid="bottombar-account" />
          <Tab icon={ShoppingBag} label="Bag" active={false} onClick={() => setOpen(true)} badge={count} testid="bottombar-bag" />
        </div>
      </nav>
    </>
  );
};

export default BottomBar;
